var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMobileDebates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11502 18.7442C1.65516 21.4233 4.49092 23.5814 5.84128 24.3256C5.61624 22.8372 4.40262 20.4186 5.1661 17.6279C5.64268 15.8859 7.41672 13.907 8.54206 13.1628C8.54206 14.8372 9.00372 16.5403 9.21724 17.0698C9.89242 18.7442 11.918 20.9768 11.918 20.9768C12.5048 20.4186 13.7668 19.8604 15.2055 18.7442C15.2055 18.7442 15.3822 19.8605 14.6187 21.5349C13.8551 23.2093 12.5931 24.8837 11.918 26C13.2683 25.4419 19.9318 23.2093 19.9318 16.5116C19.9318 12.6046 18.5814 11.4884 16.5559 9.25581C16.5559 10.3721 16.8267 12.3708 16.5559 13.1628C15.7923 15.3953 14.6187 15.9535 13.18 16.5116C14.442 13.1628 14.5303 10.3721 13.18 7.5814C11.918 4.97329 8.54206 3.11628 7.1917 2C7.1917 3.11625 5.28093 7.11544 3.72742 9.25581C1.70189 12.0465 0.439836 15.3954 1.11502 18.7442Z",
    stroke: "#989898",
    fill: "none",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileDebates);
export default __webpack_public_path__ + "static/media/icon-mobile-debates.f03aeb2e19baa772d5f71dc235a16d12.svg";
export { ForwardRef as ReactComponent };